import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put('update/funding-and-monitoring/student-course-session', payload)
}
